import { render, staticRenderFns } from "./DynamicDataList.vue?vue&type=template&id=e3c11804"
import script from "./DynamicDataList.vue?vue&type=script&lang=ts"
export * from "./DynamicDataList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports